import { render, staticRenderFns } from "./salesOrderHistories.vue?vue&type=template&id=3380c899&scoped=true&"
import script from "./salesOrderHistories.vue?vue&type=script&lang=js&"
export * from "./salesOrderHistories.vue?vue&type=script&lang=js&"
import style0 from "./salesOrderHistories.vue?vue&type=style&index=0&id=3380c899&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3380c899",
  null
  
)

component.options.__file = "salesOrderHistories.vue"
export default component.exports